import { Component, Input, Output, EventEmitter, ViewChild, ViewContainerRef, TemplateRef, ElementRef } from '@angular/core';
import { forkJoin } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StateService, AuthService } from '../../../services';
import { FilterItemValue } from '../../../models';
import { AuctionLotSearchFilterItemChoicesModel } from '../../models';
import { FormFunctions } from '../../../functions';
import { Validations } from '../../../constants'

@Component({
  selector: 'modal-search-filter-item-choices',
  templateUrl: 'modal-search-filter-item-choices.component.html'
})
export class ModalSearchFilterItemChoicesComponent {
  processing: boolean = false;
  error: boolean = false;
  errorMessage: string = "";

  searchTerm: string = "";

  @Input() model: AuctionLotSearchFilterItemChoicesModel;

  selectedValues: string[];
  selected: boolean[];

  @Output() apply: EventEmitter<FilterItemValue[]> = new EventEmitter();

  @ViewChild("txt") txt: ElementRef;

  constructor(public activeModal: NgbActiveModal, public stateService: StateService, public validations: Validations, public formFunctions: FormFunctions, public authService: AuthService) {
    let me = this;
  }

  ngOnInit() {

  }

  Save(values) {
    var me = this;

    // const values = me.model.options.filter((x, i) => me.selected[i]);
    me.apply.emit(values);
    me.activeModal.close();
  }

  Close(evt) {
    var me = this;
    me.activeModal.close(null);
  }

  // ngOnInit() {
  //   let me = this;
  //   setTimeout(() => { me.txt?.nativeElement.select(); }, 0); // focus on the text box when the modal opens

  //   me.selectedValues = me.model.values.map(x => x.value);
  //   me.selected = me.model.options.map(x => me.selectedValues.includes(x.value));

  //   // Using manual + progressive rendering https://blog.bitsrc.io/3-ways-to-render-large-lists-in-angular-9f4dcb9b65
  //   this.buildData(me.model.options.length);
  // }
  // Save(form) {
  //   var me = this;

  //   const values = me.model.options.filter((x, i) => me.selected[i]);
  //   me.apply.emit(values);
  //   me.activeModal.close();
  // }

  // Close(evt) {
  //   var me = this;
  //   me.activeModal.close(null);
  // }

  // @ViewChild('itemsContainer', { read: ViewContainerRef }) container: ViewContainerRef;
  // @ViewChild('item', { read: TemplateRef }) template: TemplateRef<any>;

  // private buildData(length: number) {
  //   let me = this;
  //   const ITEMS_RENDERED_AT_ONCE = 300;
  //   const INTERVAL_IN_MS = 10;

  //   let currentIndex = 0;

  //   const interval = setInterval(() => {
  //     const nextIndex = currentIndex + ITEMS_RENDERED_AT_ONCE;

  //     for (let n = currentIndex; n <= nextIndex; n++) {
  //       if (n >= length) {
  //         clearInterval(interval);
  //         break;
  //       }
  //       const context = {
  //         item: me.model.options[n],
  //         i: n,
  //       };
  //       this.container.createEmbeddedView(this.template, context);
  //     }

  //     currentIndex += ITEMS_RENDERED_AT_ONCE;
  //   }, INTERVAL_IN_MS);
  // }

  // keyPress($event) {
  //   let me = this;
  //   if (me.model.validation) {
  //     return /[a-zA-Z ]/i.test($event.key)
  //   }
  // }
}